import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';

import SaleFooter from '../SaleFooter/SaleFooter';

import {goToPage, reportAnalytics, setIsCustomerConnectedToIbc} from '../saleBlockSlice';
import IsIBCInternetCustomer from '../IsIBCInternetCustomer/IsIBCInternetCustomer';

const FiberUpgradesPage = (props) => {
  let flowType = props.flowType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'visibility_9', eventLabel: eventLabel});
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handleIsIBCInternetCustomerPageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'sale';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> רק עוד בירור קטן </h1>
    </div>
  );

  let currentPageView = <IsIBCInternetCustomer />;

  function handleIsIBCInternetCustomerPageContinue() {
    const isCustomerConnectedToIbc = props._isIBCInternetCustomer.isIBC == 'isIBC';
    props.setIsCustomerConnectedToIbc(isCustomerConnectedToIbc);

    if (flowType == 'existsCustomer') {
      props.goToPage({page: 'technicianPage', percent: 36});
    } else {
      props.goToPage({page: 'technicianPage', percent: 50});
    }

    const eventLabel = props.productsInfo.selectedProducts[0]?.name; //click_13
    props.reportAnalytics({
      eventCategory: 'fiber_newsale_process',
      eventAction: isCustomerConnectedToIbc ? 'click_9' : 'click_10',
      eventLabel: eventLabel,
    });
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        {currentPageView}
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    productsInfo: state.saleBlock.productsInfo,

    //other states
    _isIBCInternetCustomer: state.IsIBCInternetCustomer,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setIsCustomerConnectedToIbc,
};

export default connect(mapStateToProps, mapDispatchToProps)(FiberUpgradesPage);
